import { writable } from 'svelte/store';
import firebase from '../firebase';
import functions from '../functions';

export const currentUser = writable(null);

firebase.auth().onAuthStateChanged(async user => {
    currentUser.set(await getUserState(user));
});

const getUserState = async user => {
    if (!user) {
        return { userNotFound: true, isLoggedIn: false };
    }
    functions.setUser(user);
    const auth = await functions.get(`userAuth/${user.uid}`, { user });
    if (!user.emailVerified || !auth.member) {
        return { ...user, auth, isLoggedIn: false }
    }
    const data = await functions.get(`userData/${user.uid}`, { user });
    return { ...user, auth, data, isLoggedIn: true }
}